import { useMutation } from '@apollo/client';
import { gql } from '__generated__/gql';
import { FC, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { NavLink } from 'react-router-dom';

import AuthSplitLayout from 'layouts/AuthSplitLayout';

import { FormInput, FormPanel } from 'components/FormPanel';

import Alert from 'primitives/Alert';
import Button from 'primitives/Button';
import Divider from 'primitives/Divider';

const SEND_OTP_MUTATION = gql(`
  mutation SendOTP($email: String!) {
    sendOTP(email: $email)
  }
`);

const Login: FC = () => {
  const location = useLocation();
  const buttonRef = useRef<HTMLButtonElement>(null);
  const navigate = useNavigate();
  const [sendOTP, { error, loading }] = useMutation(SEND_OTP_MUTATION);

  return (
    <AuthSplitLayout title="Sign in to your account">
      <div>
        <FormPanel
          loading={loading}
          error={error}
          onSubmit={formData => {
            const email = formData.email.trim();
            sendOTP({
              variables: {
                email,
              },
            }).then(({ data }) => {
              if (data?.sendOTP === true) {
                navigate(`/authenticate-otp?email=${encodeURIComponent(email)}`, {
                  state: { from: location.state?.from },
                });
              }
            });
          }}
          buttonRef={buttonRef}
        >
          <FormInput
            fieldName="email"
            type="text"
            defaultValue=""
            label="Email"
            fullWidth
            validators={{
              required: true,
              isEmail: true,
              maxLength: 255,
            }}
          />
        </FormPanel>
        <div className="mt-6">
          <Button
            loading={loading}
            className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            onClick={() => {
              // @ts-ignore
              buttonRef.current?.submit();
            }}
          >
            Send One-Time Password
          </Button>
          <div className="mt-6">
            <Divider />
            <Alert
              type="info"
              title="How is AngelList India different from AngelList?"
              message="AngelList India runs on a separate platform with a dedicated team, focused on serving Indian users and complying with Indian market, securities, and data regulations."
              buttonText="Read more"
              onClick={() =>
                window.open(
                  'https://medium.com/@AngelListIndia/introducing-a-new-platform-for-india-854cc8b909a4',
                  '_blank'
                )
              }
            />
          </div>
        </div>
      </div>

      <p className="mt-10 text-center text-sm text-gray-500">
        New to AngelList India?{' '}
        <NavLink
          to="/signup"
          className="font-semibold leading-6 text-indigo-600 hover:text-indigo-500"
        >
          Create an account
        </NavLink>
      </p>
    </AuthSplitLayout>
  );
};

export default Login;
